/* global window */

import { Component } from 'react';
import { connect } from 'react-redux';

import { removeFormError, setScrollTopOff } from 'redux/formErrors/actions';

class FormError extends Component {
  componentDidUpdate() {
    const { props } = this;
    if (this.errorNode && props.scrollTop) {
      this.errorNode.scrollIntoView();
      window.scrollBy(0, -150);
      props.setScrollTopOff();
    }
  }

  render() {
    const { formError, form } = this.props;
    // If we dont have form errors
    if (!formError) {
      return null;
    }

    if (!form) {
      return null;
    }

    return (
      <div
        className="c7-message--error"
        ref={(div) => {
          this.errorNode = div;
        }}
      >
        Error: Please fix the form errors below.
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { formName } = props;
  return {
    formError: state.formError.formError,
    scrollTop: state.formError.scrollTop,
    form: formName && state.form?.[formName]?.fields
  };
};

export default connect(mapStateToProps, { removeFormError, setScrollTopOff })(
  FormError
);
